var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createElement } from 'react';
import { useClassNames, Span } from '@tpr/core';
import styles from './elements.module.scss';
export var StyledInputLabel = function (_a) {
    var _b;
    var _c = _a.element, element = _c === void 0 ? 'label' : _c, cfg = _a.cfg, isError = _a.isError, className = _a.className, children = _a.children, noLeftBorder = _a.noLeftBorder, _d = _a.hiddenLabel, hiddenLabel = _d === void 0 ? '' : _d, hiddenLabelId = _a.hiddenLabelId, props = __rest(_a, ["element", "cfg", "isError", "className", "children", "noLeftBorder", "hiddenLabel", "hiddenLabelId"]);
    var classNames = useClassNames(cfg, [
        styles.label,
        (_b = {}, _b[styles['labelError']] = isError && !noLeftBorder, _b),
        className,
    ]);
    return createElement(element, __assign({ className: classNames }, props), React.createElement(React.Fragment, null,
        hiddenLabel && (React.createElement("div", { className: styles.hiddenLabel, id: hiddenLabelId }, hiddenLabel)),
        children));
};
export var FormLabelText = function (_a) {
    var _b = _a.element, element = _b === void 0 ? 'div' : _b, _c = _a.id, id = _c === void 0 ? null : _c, children = _a.children, labelNotBold = _a.labelNotBold, forId = _a.forId;
    var classNames = useClassNames({}, [
        styles.labelText,
        labelNotBold && styles.labelNoBold,
    ]);
    return createElement(element, {
        id: id,
        className: classNames,
        htmlFor: forId,
    }, children);
};
export var ErrorMessage = function (_a) {
    var id = _a.id, children = _a.children, role = _a.role;
    return (React.createElement("p", { id: id, className: styles.errorMessage, role: role }, children));
};
export var InputElementHeading = function (_a) {
    var _b = _a.element, element = _b === void 0 ? 'div' : _b, label = _a.label, required = _a.required, hint = _a.hint, meta = _a.meta, accessibilityHelper = _a.accessibilityHelper, labelNotBold = _a.labelNotBold, errorRole = _a.errorRole, forId = _a.forId;
    return (React.createElement(React.Fragment, null,
        label && (React.createElement(FormLabelText, { element: element, id: accessibilityHelper.labelId, labelNotBold: labelNotBold, forId: forId },
            label,
            " ",
            !required && '(optional)')),
        hint && (React.createElement(Span, { id: accessibilityHelper.hintId, cfg: { mb: 2 }, className: styles.hint }, hint)),
        meta && meta.touched && meta.error && (React.createElement(ErrorMessage, { id: accessibilityHelper.errorId, role: errorRole }, meta.error))));
};
//# sourceMappingURL=elements.js.map